module.exports = __webpack_public_path__ + "803ceb3fef1efc0176285e042981e5b2.png";